import * as _ from 'lodash-es';
import React, { useState } from 'react';
import * as styles from './SharingDropdownAccessLevelSelect.module.scss';
import Button from '../../components/Button';
import Caret from '../../components/Caret';
import { MenuItem, MenuItemRadio, MenuSeparator } from '../../components/Menu';
import OverflowMenu from '../../components/OverflowMenu';
import trashIcon from '../../icons/non-prefilled/16x16/trash.svg';

type AccessLevel = 'EDITOR' | 'VIEWER';

interface SharingDropdownAccessLevelSelectProps {
  changeDisabledMessage?: string;
  onChange?: (level: AccessLevel) => unknown;
  onRemove?: () => unknown;
  removeDisabledMessage?: string;
  topic?: boolean;
  value: AccessLevel;
}

const getTooltipProps = (message: string) =>
  ({
    disabled: true,
    tooltipPlacement: 'right',
    tooltip: message,
  }) as const;

const SharingDropdownAccessLevelSelect = ({
  changeDisabledMessage,
  onChange,
  onRemove,
  removeDisabledMessage,
  value,
}: SharingDropdownAccessLevelSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <OverflowMenu
      onOpenChange={setIsOpen}
      open={isOpen}
      ariaLabel="Access level options"
      button={
        <Button
          testId="accessLevelSelectButton"
          className={styles.button}
          size="small"
        >
          {_.capitalize(value)} <Caret direction={isOpen ? 'up' : 'down'} />
        </Button>
      }
      modifiers={[
        {
          name: 'offset',
          options: { offset: [6, 0] },
        },
      ]}
    >
      {(['EDITOR', 'VIEWER'] as const).map((option) => {
        return (
          <MenuItemRadio
            key={option}
            checked={value === option}
            {...(changeDisabledMessage && value !== option
              ? getTooltipProps(changeDisabledMessage)
              : { onClick: onChange && (() => onChange(option)) })}
          >
            {_.capitalize(option)}
          </MenuItemRadio>
        );
      })}
      {onRemove && <MenuSeparator />}
      {onRemove && (
        <MenuItem
          icon={trashIcon}
          danger
          {...(removeDisabledMessage
            ? getTooltipProps(removeDisabledMessage)
            : { onClick: () => onRemove() })}
        >
          Remove
        </MenuItem>
      )}
    </OverflowMenu>
  );
};

export default SharingDropdownAccessLevelSelect;
